import AntButton, { ButtonProps as AntButtonProps } from 'antd/lib/button/index'
import { Link } from 'react-router-dom'

export const Button = ({ children, href, type, ...props }: AntButtonProps) => {
  if (href) {
    return (
      <Link to={href}>
        <AntButton {...{ type }} {...props}>
          {children}
        </AntButton>
      </Link>
    )
  }
  return (
    <AntButton {...{ type }} {...props}>
      {children}
    </AntButton>
  )
}
